import { FormEvent, useCallback } from 'react';
import { observer } from 'mobx-react';
import cls from 'classnames';
import { FormikErrors } from 'formik';

import FancyInput from '@/common/components/inputs/FancyInput/FancyInput';
import FormGroup from '@/common/components/inputs/FormGroup/FormGroup';
import RichEditor from '@/common/components/RichEditor/RichEditor';
import { ForwardForm } from '@/forwarding/types/ForwardForm';

import styles from './ForwardModalForm.module.css';

export interface ForwardModalFormProps {
  values: ForwardForm;
  errors: FormikErrors<ForwardForm>;
  isTitleReadOnly?: boolean;
  className?: string;
  setFieldValue: <T extends keyof ForwardForm>(key: T, val: ForwardForm[T]) => void;
}

function ForwardModalForm(props: ForwardModalFormProps) {
  const { values, errors, isTitleReadOnly = false, className, setFieldValue } = props;

  const handleSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  }, []);

  return (
    <form className={cls(styles.forwardModalForm, className)} onSubmit={handleSubmit}>
      <FormGroup>
        <FancyInput
          name="title"
          aria-label="Title"
          placeholder="Title"
          className={cls(styles.titleInput, { [styles.readOnlyTitle]: isTitleReadOnly })}
          contentClassName={isTitleReadOnly ? styles.readOnlyTitle : undefined}
          appearance={errors.title && 'error'}
          helperText={errors.title}
          onChange={(v) => setFieldValue('title', v)}
          value={values.title}
          readOnly={isTitleReadOnly}
        />
      </FormGroup>

      <FormGroup className={styles.descriptionFormGroup}>
        <RichEditor
          onChange={(v) => setFieldValue('description', v)}
          hideToolbar
          value={values.description}
          placeholder="Description"
          className={styles.descriptionInput}
        />

        {errors.description && <div className={styles.descriptionError}>{errors.description}</div>}
      </FormGroup>
    </form>
  );
}

export default observer(ForwardModalForm);
